
    import {Add, Edit, EditForm, Delete} from './Record';
    // require('waypoints/lib/noframework.waypoints.min');

    let currentRow;
    let addRecord;
    let editRecord;
    let deleteRecord;

    // on click default add button 
    $('.default-add-button').on('click', function(e){
        e.preventDefault();
        addRecord = new Add;
    });

    // on submit add form
    $(document).on('submit','.add-form',function(e){
        e.preventDefault();
        addRecord.submit()
    });

    // edit record button
    $('.items-container').on('click', '.default-edit-button', function(e){
        e.preventDefault();
        editRecord = new Edit($(this));
    });

    // on submit edit form
    $(document).on('submit', '.edit-form', function(e){
        e.preventDefault();
        editRecord.submit();
    });


    // when form modal is closed
    $('#mdl-default-form').on('hidden.bs.modal', function () {
        $('#default-form').trigger("reset");
        $('#default-form').removeClass('update');
        $('#default-form').removeClass('add');
    })


    // arrow up and down on items row
    $('.items-container').keydown(
        function(e)
        {    
            if (e.keyCode == 40) {      
                console.log('down');
                $(".item-row:focus").next().focus();
                $('.item-row').removeClass('selected-row');
                $(".item-row:focus").toggleClass('selected-row');
                currentRow = $(".item-row:focus");
            }
            if (e.keyCode == 38) {      
                console.log('up');
                $(".item-row:focus").prev().focus();
                $('.item-row').removeClass('selected-row');
                $(".item-row:focus").toggleClass('selected-row');
                currentRow = $(".item-row:focus");
            }
        }
    );


    // enter button on items row
    $('.items-container').keydown(
        function(e)
        {
            if(e.keyCode == 13){
                var editButton = currentRow.find('.default-edit-button');
                editButton.trigger( "click" );
            }
        }
    ); 


    // loose focus event on selected row
    $('.item-row').blur(function(){
        $(this).removeClass('selected-row');
    });


    // select row
    $('.items-container').on('click', '.item-row', function(){
        $('.item-row').removeClass('selected-row');
        $(this).toggleClass('selected-row');
        $(this).attr("tabindex",-1).focus();
        currentRow = $(this);
    });


    // trigger click on edit record button
    $('.items-container').on('dblclick', '.item-row', function(){
        var editButton = $(this).find('.default-edit-button');
        editButton.trigger( "click" );
    });


    // delete row
    $('.items-container').keyup(function(e){
        if(e.keyCode == 46) {
            // deleteItem('delete-employee');
            // $(':focus').remove();
            var deleteButton = currentRow.find('.default-delete-button');
            deleteButton.trigger( "click" );
        }
    });


    // delete row function
    $('.items-container').on('click', '.default-delete-button', function(e){
        e.preventDefault();
        deleteRecord = new Delete($(this));
    });

    // confirm delete
    $('body').delegate('.confirm-delete', 'click', function(){
        deleteRecord.confirm();
    });
    
    // load more
    // $('#load-more').on('click', function(e){
    //     e.preventDefault();
    //     $.ajax({
    //         type:'get',
    //         url: `${$(this).attr('href')}`,
    //         headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
    //         success:function(data){
    //             // console.log(data);
    //             let profiles = data['data'];
    //             console.log(profiles);
    //             $.each(profiles, function(i, profile){
    //                 $('.item-row:first').clone().appendTo('.items-container');
    //                 let currentRow = $('.items-container').children().last();
    //                 currentRow.removeClass('d-none');
    //                 currentRow.attr("tabindex",-1);
    //                 let fieldItem = currentRow.find('.item-field');
    //                 $.each(fieldItem, function(i, v){
    //                     $(this).html(profile[$(this).data('name')]);
    //                     if($(this).is('a')){
    //                         $(this).attr("href", $(this).attr('href') + profile['id']);
    //                     };
    //                 });
    //             });
    //         },
    //         error:function(data){
    //             console.log('error');
    //         }
    //     });
    // });

    // $.fn.isInView = function() {
    //     var elementTop = $(this).offset().top;
    //     var elementBottom = elementTop + $(this).outerHeight();
    
    //     var viewportTop = $(window).scrollTop();
    //     var viewportBottom = viewportTop + $(window).height();
    
    //     return elementBottom > viewportTop && elementTop < viewportBottom;
    // };

    // $(window).on('scroll', function() {
    //     console.log('scrolled');
    //     if ($('#load-more').isInView()) {
    //         $('#load-more').trigger( "click" );
    //         console.log('viewed');
    //     } else {
    //         // do something else
    //     }
    // });
    // var waypoint = new Waypoint({
    //     element: document.getElementById('load-more'),
    //     handler: function(direction) {
    //         if(direction == 'down'){
    //             $('#load-more').trigger('click');
    //         }
    //     },
    //     offset: '100%'
    // });
    var infinite = new Waypoint.Infinite({
        element: $('.infinite-container')[0],
        more: '.pagination li.active + li a',
        offset: 'bottom-in-view'
    });
    